import CellView from "./cellView";
import PropTypes from "prop-types";
import {useContext, useEffect, useState} from "react";
import {CartContext} from "../../../pages/shop";
import AddedToCartToastView from "../toasts/addedToCartToastView";


export default function GridView(props) {


    // TODO: Move this code somewhere else - needs to include js Callback function
    const projects = props.projects

    const {cartData, setCartData} = useContext(CartContext)
    const [isAddToCartToastShown, setIsAddToCartToastShown] = useState(false)

    useEffect(() => {
        // TODO: Set the cartData from the local storage (Put in parent/caller shop.jsx)
        // TODO: Pull the cart data, use the IDs to load the cartData
    }, []);

    return (
        <div className="">
            {
                isAddToCartToastShown &&
                <AddedToCartToastView isVisible={isAddToCartToastShown} setIsVisible={setIsAddToCartToastShown} />
            }

            <div className="shadow-2xl rounded p-4 pt-8">
                {/*<div className="">*/}
                {/*    <div>*/}
                {/*        <h2><strong>{props.title}</strong></h2>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="m-4 p-4" style={{
                    // background: "#E9EEFA"
                }}>
                    <div className="">
                        <div>
                            <div className="mb-8">
                                <h2 className="">
                                    <div className="flex space-x-4 custom-font text-4xl sm:text-7xl">
                                        <strong>{props.sectionTitle}</strong>
                                        <div className="cursor-pointer" onClick={() => {
                                            props.generalCTA()
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                 fill="currentColor"
                                                 className="size-6">
                                                <path fillRule="evenodd"
                                                      d="M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z"
                                                      clipRule="evenodd"/>
                                            </svg>
                                        </div>
                                    </div>
                                </h2>
                                <i className="custom-font font-thin">{props.subtitle}</i>
                            </div>
                            <p className="">
                                {props.description}
                            </p>
                        </div>
                    </div>
                    <div className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-1 sm:gap-6 md:grid-cols-2 ">
                        {projects.map((project) => (
                            <div id={project.slugName} key={project.id} className="rounded-md shadow-sm">
                                <div className="">
                                    <CellView isSelected={cartData.some(obj => obj.id === project.id)}
                                              setIsSelected={(isSelected) => {
                                                  if (isSelected) {
                                                      let selectedArray = [...cartData, project]
                                                      setCartData(selectedArray)
                                                      localStorage.setItem("selectedItems", JSON.stringify(selectedArray))
                                                      setIsAddToCartToastShown(true)
                                                  } else {
                                                      // Removes the ID from the list
                                                      let tempArray = []
                                                      tempArray = cartData.filter(obj => obj.id !== project.id);
                                                      setCartData(tempArray)
                                                      localStorage.setItem("selectedItems", JSON.stringify(tempArray))
                                                  }
                                              }} project={project}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}


GridView.propTypes = {
    projects: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    description: PropTypes.string,
    generalCTA: PropTypes.func,
}

